// Analytics beacons from the public form page — view, per-page view, first
// keystroke, submit. Fire-and-forget by design: sendBeacon when the browser
// has it (it survives page unloads), keepalive fetch otherwise, and silence
// on every failure — analytics must never be a respondent's problem.
//
// The visitor id is a random value minted in this browser and kept in
// localStorage so return visits count once; the server stores only a hash of
// it. No IP, no fingerprinting — a cleared storage is simply a new visitor.

const VISITOR_KEY = 'fm-visitor';

export function visitorId(): string {
  try {
    const existing = window.localStorage.getItem(VISITOR_KEY);
    if (existing) return existing;
    const fresh = crypto.randomUUID();
    window.localStorage.setItem(VISITOR_KEY, fresh);
    return fresh;
  } catch {
    return ''; // storage unavailable: events still count, uniques just can't
  }
}

export type FormEventName = 'view' | 'page_view' | 'start' | 'submit';

export function track(formPath: string, event: FormEventName, page?: number): void {
  try {
    const body = JSON.stringify({ event, ...(page !== undefined ? { page } : {}), ...(visitorId() ? { visitor: visitorId() } : {}) });
    const url = `/api/public/forms/${formPath}/events`;
    if (navigator.sendBeacon && navigator.sendBeacon(url, new Blob([body], { type: 'application/json' }))) return;
    void fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body, keepalive: true })
      .catch(() => undefined);
  } catch { /* never a respondent's problem */ }
}
